module.exports = __webpack_public_path__ + "static/media/rocket.c7ed28b7.svg";